import { render, staticRenderFns } from "./ProspectsTable.vue?vue&type=template&id=770cb344&scoped=true"
import script from "./ProspectsTable.vue?vue&type=script&lang=js"
export * from "./ProspectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cb344",
  null
  
)

export default component.exports